import { UploadStatus } from '../Constants';
export const getFileDataUploadStatus = fileData => {
  if (!fileData) {
    return UploadStatus.NOT_STARTED;
  }

  if (fileData.has('errorCode')) {
    return UploadStatus.FAILED;
  }

  return UploadStatus.FINISHED;
};